import { Get } from "../Repository";

import * as API from "./customer.api";
import { CustomerDTO, SearchCustomerDTO } from "./customer.dto";

async function searchCustomer(
  options: SearchCustomerDTO
): Promise<CustomerDTO> {
  const response = await Get(API.route, options);

  return response as CustomerDTO;
}

export { searchCustomer };
